import { EType } from 'shared/repositories/text-search/entities/tips/FullTipSchema';

export const RUNTIME_NAME = '/v1/get-search-string-microfrontend/';

export const MAINPAGE_SEARCH_URL = '/nd/search/';

const MAINPAGE_FILTERS_URL_PREFIX = '/nd/search/?deal_type=sale&engine_version=2&offer_type=flat&region=';

export function getMainpageFiltersUrl(regionId: number): string {
  return `${MAINPAGE_FILTERS_URL_PREFIX}${regionId}`;
}

export const SEARCH_TIPS = [
  {
    fullText: 'купить квартиру',
    text: 'купить квартиру',
    type: EType.Regular,
  },
  {
    fullText: 'снять надолго',
    text: 'снять надолго',
    type: EType.Regular,
  },
  {
    fullText: 'снять посуточно',
    text: 'снять посуточно',
    type: EType.Regular,
  },
  {
    fullText: 'построить дом',
    text: 'построить дом',
    type: EType.Regular,
  },
  {
    fullText: 'купить участок',
    text: 'купить участок',
    type: EType.Regular,
  },
];
